<template>
    <transition name="fade">
        <div
            class="modal"
            :class="value ? 'show' : 'hide'"
            :style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-row align-items-center">
                    <h3>Demande #{{ row_cr.cr_id }} 
                        <span v-show="mustCallBack(row_cr.cr_reason, row_cr.cr_status)">
                             - <icon name="phone-alt" scale="1.5" color="green"/>
                        </span>
                    </h3>
                </div>
                <div class="modal-body">

                    <div v-if="editionMode" class="row">
                        <div class="col col-lg-7">
                            <h4>Mettre à jour le statut</h4>

                            <m-form-select
                                label="Nouveau statut"
                                label-position="top"
                                :name="$Utils.randomstring('filterStatus')"
                                v-model="status"
                                :items="$store.state.items_cr_statuses"
                            />

                            <m-form-text 
                                :rows="8"
                                label="Commentaire"
                                type="textarea"
                                v-model="comment"
                            />

                            <div v-if="commentError" class="text-danger">{{ commentError }}</div>

                            <div v-show="status === 'KIT_BACK_COMPLETE_DEFECT' || status === 'KIT_BACK_INCOMPLETE'">
                                <m-form-file
                                    label="Télécharger une photo"
                                    type="image"
                                    v-model="file"
                                    @inputfile="savefile"
                                />
                            </div>

                        </div>
                        <div class="col col-lg-5">

                            <h4>Réponses prédéfinies</h4>

                            <ul >
                                <li v-for="(message, index) in predefinedMessagesList" :key="index" @click="setPredefinedMessages(message.key)">
                                    {{ message.description }}
                                </li>
                            </ul>

                        </div>
                    </div>
                    
                    <div v-else class="row">

                        <div class="col-12 col-lg-6">

                            <h4>Information</h4>
                            <table class="table table-sm">
                                <tbody>
                                    <!--tr>
                                        <td class="text-right cr_label_cell">Demande du&nbsp;:</td>
                                        <td>
                                            <span>
                                                {{ $moment(row_cr.createdAt).format("DD/MM/YYYY HH:mm") }}
                                            </span>
                                        </td>
                                    </tr-->
                                    <tr>
                                        <td class="text-right cr_label_cell">Contact&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToContactDetails">
                                                {{ row_cr.co_id.co_invoice_firstname }} {{ row_cr.co_id.co_invoice_name }}
                                            </a>
                                            <div>
                                                <small>
                                                    <a :href="$Utils.formatPhoneNumber(row_cr.co_id.co_invoice_tel, row_cr.co_id.co_invoice_country).getURI()">
                                                        {{ $Utils.formatPhoneNumber(row_cr.co_id.co_invoice_tel, row_cr.co_id.co_invoice_country).formatInternational() }}
                                                    </a>
                                                </small>
                                            </div>
                                            <div>
                                                <small>
                                                    <a :href="`mailto:${row_cr.co_id.co_invoice_email}`">
                                                        {{ row_cr.co_id.co_invoice_email }}
                                                    </a>
                                                    </small>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">Bénéficiaire&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToBoxDetails">
                                                {{ row_cr.en_id.en_fullname }}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">Motif&nbsp;:</td>
                                        <td>
                                            <span>
                                                {{ getCancellationReason(row_cr.cr_reason).join('. ') }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">Comment.&nbsp;:</td>
                                        <td>
                                            <span v-if="row_cr.cr_reason_comment">
                                                {{ row_cr.cr_reason_comment }}
                                            </span>
                                            <span v-else>
                                                    - 
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">Documents :</td>
                                        <td>
                                            <div v-if="row_cr.cr_documents">
                                                <div v-for="(file, fileIndex) in row_cr.cr_documents.list" :key="fileIndex">
                                                    <a target="_blank" :href="`${$config.server_url}/${file.path}`" :download="file.name">{{  file.name }}</a>
                                                </div>
                                            </div>
                                            <div v-else> - </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">
                                            Statut&nbsp;:
                                        </td>
                                        <td>
                                            {{ getCancellationStatus(row_cr.cr_status) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right cr_label_cell">
                                            Mis à jour le&nbsp;:
                                        </td>
                                        <td>
                                            {{ $moment(row_cr.cr_status_date).format("DD/MM/YYYY HH:mm") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div class="col-12 col-lg-6">
                            <h4>Suivi de la demande</h4>
                            <table class="table table-sm">
                                <tbody>
                                    <tr v-for="(item, index) in row_cr.cr_history.list" :key="index">
                                        <td class="cr_label_cell">
                                            {{ $moment(item.date).format("DD/MM/YYYY HH:mm") }}
                                        </td>
                                        <td>
                                            {{ getCancellationStatus(item.status) }}
                                            <p v-if="item.comment">
                                               <i><pre>{{ item.comment }}</pre></i>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                        </div>

                    </div>
                  
                
                </div>
                <div class="modal-footer">

                    <div v-if="editionMode">
                        <button type="button" class="btn btn-secondary" @click="cancelEditStatus">Annuler</button>
                        <button type="button" class="btn btn-primary ml-2" @click="updateStatus">Mettre à jour</button>
                    </div>
                    <div v-else>
                        <button type="button" class="btn btn-secondary" @click="cancelWin">Fermer</button>
                        <button type="button" class="btn btn-primary ml-2" @click="editStatus">Modifier</button>
                    </div>


                </div>
            </div>
        </div>
        <m-message-dialog v-model="dialogErr" title="Erreur" :text="dialogErrTxt"></m-message-dialog>
        </div>
    </transition>
</template>

<script>
export default {
    name: "cancellationWinEdit",

    components: {},

    props: {
        value: {
            default: false,
            type: Boolean
        },

        row_cr_p: {
            default: null,
            type: Object
        }
    },

    data() {
        return {
            row_cr: { 
                co_id: {},
                en_id: {},
                cr_id: undefined,
                cr_reason: "",
                cr_history: {list: []},
                cr_documents: {list: []}
            },
            status: '',
            comment: '',
            commentError: '',
            attachment: '',
            file: undefined,
            editionMode: false,
            dialogCancellation: false,
            dialogErrTxt: "",
            dialogErr: false,
            predefinedMessages: {
                RDV: {
                    content: "Vous avez demandé un rendez-vous afin que nous puissions résoudre le problème évoqué. Vous avez raison car plusieurs utilisateurs de nos abonnés nous remercient d'avoir pu continuer à maintenir le lien avec leurs proches grâce à notre intervention. Nous vous remercions de nous indiquer à quels moments nous pouvons vous contacter pour organiser ce rendez-vous.",
                    description: "Proposition de RDV"
                },
                TECH_ISSUE: {
                    content: "Ce problème est déjà survenu chez d’autres de nos utilisateurs, et nous avons réussi à le résoudre. Nous vous proposons d'en discuter lors d’un échange téléphonique. A quels moments pouvons-nous vous appeler pour fixer ensemble un créneau ?",
                    description: "Problème connu"
                },
                MOVE: {
                    content: "EMOTIVI est adaptable à tout environnement. Il suffira simplement de reconfigurer la box pour qu’elle s’intègre au nouveau réseau.\r\n\r\nPour un EPHAD, nous vous recommandons d’avertir au préalable l’établissement de votre souhait que votre proche puisse continuer à échanger avec ses proches grâce à EMOTIVI. Vous trouverez ci-joint un document que vous pourrez leur remettre. Bien sûr, nous restons à votre disposition pour vous accompagner dans cette démarche.",
                    description: "Le senior déménage",
                    attachment: "EMOTIVI - Certificat de confidentialite.pdf"
                },
                PICKUP: {
                    content: "Vous avez 2 solutions possibles en fonction de la situation de votre proche. Soit remplacer le bouton par une télécommande simplifiée, soit configurer l'option de décrochage automatique qui évite le besoin pour votre proche de devoir faire une manipulation. Le nombre de sonneries dans ce cas avant le décrochage est paramétrable. Si vous avez besoin de précisions pour mettre en place cette solution, n’hésitez pas à nous contacter par email ou par téléphone. Notre équipe reste à votre disposition pour vous accompagner.",
                    description: "Le senior ne décroche pas"
                },
                COMMUNICATION: {
                    content: "Les études montrent que le maintien du bien-être passent aussi par le fait de savoir qu'on n'est pas oublié par ses proches. C'est ce que propose le service qui transforme ainsi la télé en cadre numérique photo en grand format. Si vous avez besoin de précisions, n’hésitez pas à nous contacter par email ou par téléphone. Notre équipe reste à votre disposition pour vous accompagner.",
                    description: "Le senior ne communique plus"
                }
            }
        };
    },

    computed: {
        predefinedMessagesList() {
            return Object.keys(this.predefinedMessages).map(key => ({
                key,
                description: this.predefinedMessages[key].description
            }));
        }
    },

    mounted() {
        this.user = this.$store.state.user;
        window.addEventListener("keyup", this.onKeyup);
    },

    destroyed() {
        window.removeEventListener("keyup", this.onKeyup);
    },

    created() {},

    watch: {
        row_cr_p(value) {
            this.row_cr = value;
        }
    },

    methods: {

		getBase64File(path) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(path);
				reader.onload = () => resolve(reader.result);
				reader.onerror = reject;
			});
		},

        savefile(files) {
            if (files.length) this.file = files[0];
        },

        onKeyup(e) {
            if (e.key === "Escape") {
                this.cancelWin();
            }
        },

        mustCallBack(reason, status) {
            return reason.split('.').indexOf("CALL_ME_BACK") !== -1 && status === "INITIAL"
        },

        goToContactDetails() {
            this.$router.push(`/contacts/${this.row_cr.co_id.co_id}/details`);
            this.$emit("input", false);
        },
       

        goToBoxDetails() {
            this.$router.push(`/boxes/${this.row_cr.en_id.en_id}`);
            this.$emit("input", false);
        },

        getCancellationStatus(value) {
            const result = this.$store.state.items_cr_statuses.find(status => status.value === value);
            return result ? result.text : "???";
        },

        getCancellationReason(value) {
            return value.split(".").map(key => {
                const result = this.$store.state.items_cr_reasons.find(reason => reason.value === key);
                return result ? result.text : "???";
            });
        },

        editStatus() {
            this.editionMode = true;
        },

        cancelEditStatus() {
            this.editionMode = false;
        },

        setPredefinedMessages(key) {
            const predefinedMessage = this.predefinedMessages[key];
            if(predefinedMessage) {
                this.comment = predefinedMessage.content;
                this.attachment = predefinedMessage.attachment || "";
            }
        },

        async updateStatus() {
            
            if(!this.status) {
                return
            }

            const comments_required = {
                INITIAL: 0,
                MUST_CONTACT_USER: 0,
                WAITING_KIT_BACK: 0,
                REQUEST_SUSPENDED: 1,
                REQUEST_CANCELLED: 0,
                KIT_BACK_COMPLETE: 0,
                KIT_BACK_COMPLETE_DEFECT: 1,
                KIT_BACK_INCOMPLETE: 1,
                SUBSCRIPTION_CANCELLED: 0,
                SUBSCRIPTION_SILENTLY_CANCELLED: 0,
                KIT_TEST_KO: 1
            }

            if(comments_required[this.status] && this.comment.length === 0) {
                this.commentError = "un commentaire est requis pour ce statut";
                return;
            } else {
                this.commentError = "";
            }

            let documents = [];

            if(this.file) {
                documents.push({
					name: this.file.name,
					data: await this.getBase64File(this.file),
					type: this.file.type
                });
            }

            const response = await this.$axios.put(`${this.$config.server_url}/extranet/2.0/cancellationRequest/${this.row_cr.cr_id}`, {
                cr_id: this.row_cr.cr_id,
                cr_status: this.status,
                cr_status_comment: this.comment,
                cr_status_attachment: this.attachment,
                cr_documents: documents
            });

            this.editionMode = false;

            this.comment = "";
            this.status = "";
            this.attachment = "";
            this.file = undefined;

            if (response.data.err) {
                this.$store.dispatch("showDialogError", response.data.err.message);
                return;
            }

            this.row_cr = {
                ...this.row_cr,
                cr_status: response.data.row_cr.cr_status,
                cr_status_comment: response.data.row_cr.cr_status_comment,
                cr_status_date: response.data.row_cr.cr_status_date,
                cr_history: response.data.row_cr.cr_history
            }
    
            this.$emit("reload", false);
        },
        cancelWin() {
            this.comment = "";
            this.status = "";
            this.attachment = "";
            this.file = undefined;
            this.$emit("input", false);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "../scss/styles.scss";

    .table {
        table-layout: fixed;
    }

    .table tr:nth-child(odd) {
        background-color: inherit;
    }

    .table tr:hover {
        background-color: inherit;
        cursor: inherit;
    }

    .table tr td {
        border: 0;
    }

    .cr_label_cell {
        width: 160px;
        font-weight: 500;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin-bottom: 3px;
        padding: 2px 4px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #c0c0c0;
        border-radius: 3px;
    }

    li:hover {
        background-color: #f5f5f5
    }

    pre {
        white-space: break-spaces;
    }
</style>
